import { Award } from "lucide-react";
import { SEALS } from "@/lib/quality";

const CLS = {
  ouro: "bg-gold text-neutral-900 border-gold",
  prata: "bg-neutral-100 text-neutral-800 border-neutral-300",
  bronze: "bg-gold-soft text-gold-dark border-gold/40",
};

export const SealBadge = ({ level, testId }) =>
  level ? (
    <span data-testid={testId} className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${CLS[level]}`}>
      <Award className="h-3.5 w-3.5" /> {SEALS[level].label}
    </span>
  ) : (
    <span data-testid={testId} className="text-xs text-neutral-400">Sem selo</span>
  );
